import {
  Box,
  Typography,
  Select,
  MenuItem,
  FormHelperText,
  CircularProgress,
} from '@mui/material';
import React, { forwardRef } from 'react';

import styles from './styles';

type ItemBase = {
  id: string | number;
  text: string | number;
};

interface CustomSelectProps {
  helperText?: string;
  loading?: boolean;
  underline?: boolean;
  label: any;
  sx?: object; // sx özelliğini ekledik
  value?: any;
  onChange?: (value: any) => void;
}

interface Props<T extends ItemBase> extends CustomSelectProps {
  options: T[];
}

function LoadingComponent() {
  return <CircularProgress size={30} sx={{ m: 1 }} />;
}

const FormSelectComponent = forwardRef((
  { options, label, helperText, sx, loading, underline, ...props }: any,
  ref: React.ForwardedRef<HTMLSelectElement>,
) => {
  return (
    <Box
      sx={[styles.container, ...(sx ? (Array.isArray(sx) ? sx : [sx]) : [])]}
    >
      <Typography variant="subtitle1">{label}</Typography>
      <Select
        ref={ref}
        variant="outlined"
        sx={styles.selectField}
        SelectDisplayProps={{
          style: { paddingTop: 10, paddingBottom: 10 },
        }}
        fullWidth
        displayEmpty
        disableUnderline={!underline}
        color="success"
        inputProps={{ disabled: !!loading, disableUnderline: !!loading }}
        IconComponent={loading ? LoadingComponent : undefined}
        {...props}
      >
        {options.map((option: any) => (
          <MenuItem key={option.id} value={option.id}>
            {option.text}
          </MenuItem>
        ))}
      </Select>
      {helperText && (
        <FormHelperText sx={{ color: 'error.main' }}>
          {helperText}
        </FormHelperText>
      )}
    </Box>
  );
});

export default FormSelectComponent;
